import Splide from '@splidejs/splide';

document.querySelectorAll('.js-about').forEach((carousel) => {
  const slider = new Splide(carousel, {
    arrows: false,
    pagination: true,
    fixedWidth: '980px',
    gap: 60,
    perMove: 1,
    breakpoints: {
      1366: {},
      1024: {
        fixedWidth: '600px',
        gap: 30,
      },
      767: {
        fixedWidth: '300px',
        gap: 20,
      },
    },
  });

  slider.mount();

  const prevButton = carousel.querySelector('.splide__nav--prev');
  const nextButton = carousel.querySelector('.splide__nav--next');
  const navItems = carousel.closest('.about__wrapper').querySelectorAll('.about__nav > div');

  const updateControls = () => {
    const isLoop = slider.options.type === 'loop';
    if (!isLoop) {
      if (prevButton) {
        prevButton.disabled = slider.index === 0;
      }
      if (nextButton) {
        const lastPossibleIndex = slider.length - slider.options.perPage;
        nextButton.disabled = slider.index >= lastPossibleIndex;
      }
    } else {
      if (prevButton) prevButton.disabled = false;
      if (nextButton) nextButton.disabled = false;
    }

    navItems.forEach((item, index) => {
      if (index === slider.index) {
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    });
  };

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => slider.go('<'));
    nextButton.addEventListener('click', () => slider.go('>'));
  }

  navItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      slider.go(index);
    });
    item.style.cursor = 'pointer';
  });

  slider.on('moved', updateControls);
  updateControls();
});
